/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../../_chunks/dep-f7837681.mjs';
import { _ as _defineProperty } from '../../../_chunks/dep-a26b9c60.mjs';
import { defineComponent, computed, reactive, watch, createVNode, mergeProps } from 'vue';
import { t as throttle_1 } from '../../../_chunks/dep-99b45a9d.mjs';
import props from '../../props.mjs';
import '../../utils/index.mjs';
import { Input } from '../../../input/index.mjs';
import { InputNumber } from '../../../input-number/index.mjs';
import { FORMAT_INPUT_CONFIG } from './config.mjs';
import { Color } from '../../../_common/js/color-picker/color.mjs';
import '../../../_chunks/dep-6bcce672.mjs';
import '../../../_chunks/dep-b333ab93.mjs';
import '../../../_chunks/dep-6f3e4f56.mjs';
import '../../../_chunks/dep-9239b808.mjs';
import '../../../_chunks/dep-4efc69ee.mjs';
import '../../../_chunks/dep-97c71289.mjs';
import '../../../_chunks/dep-b1060562.mjs';
import '../../../_chunks/dep-8bda6dda.mjs';
import '../../../_chunks/dep-36563716.mjs';
import '../../../_chunks/dep-8049d2e0.mjs';
import '../../../_common/js/color-picker/index.mjs';
import '../../../_common/js/color-picker/cmyk.mjs';
import '../../../_common/js/color-picker/draggable.mjs';
import '../../../_chunks/dep-6d195cc7.mjs';
import '../../../_chunks/dep-71e8e343.mjs';
import '../../../_chunks/dep-5f6c8826.mjs';
import '../../../_chunks/dep-0d1bd08c.mjs';
import '../../../_chunks/dep-c5d88cfe.mjs';
import '../../../_chunks/dep-c45cdd10.mjs';
import '../../../_chunks/dep-89b33ff6.mjs';
import '../../../input/input.mjs';
import '../../../_chunks/dep-9c7a32ff.mjs';
import 'tdesign-icons-vue-next';
import '../../../input/props.mjs';
import '../../../form/hooks.mjs';
import '../../../hooks/useConfig.mjs';
import '../../../config-provider/useConfig.mjs';
import '../../../_chunks/dep-493c38ce.mjs';
import '../../../_chunks/dep-b56b2dc0.mjs';
import '../../../_chunks/dep-77f634fb.mjs';
import '../../../_chunks/dep-28ae3cda.mjs';
import '../../../_chunks/dep-e50fa7b0.mjs';
import '../../../_chunks/dep-ae08d6c4.mjs';
import '../../../_chunks/dep-7211604f.mjs';
import '../../../_chunks/dep-75df64b1.mjs';
import '../../../_chunks/dep-48b9a098.mjs';
import '../../../_chunks/dep-c7e4942d.mjs';
import '../../../_chunks/dep-25d66c95.mjs';
import '../../../_chunks/dep-372265bb.mjs';
import '../../../_chunks/dep-d940e2da.mjs';
import '../../../_chunks/dep-52c1d6a9.mjs';
import '../../../_chunks/dep-18bb982b.mjs';
import '../../../_chunks/dep-c57d8117.mjs';
import '../../../_chunks/dep-6043e9fc.mjs';
import '../../../_chunks/dep-3a045465.mjs';
import '../../../_chunks/dep-53dc0ac1.mjs';
import '../../../_chunks/dep-b6b4eaa3.mjs';
import '../../../_chunks/dep-881cffb7.mjs';
import '../../../_chunks/dep-436b338d.mjs';
import '../../../_common/js/global-config/default-config.mjs';
import '../../../_common/js/global-config/locale/zh_CN.mjs';
import '../../../_chunks/dep-2d31a683.mjs';
import '../../../_chunks/dep-3ddc95d0.mjs';
import '../../../config-provider/type.mjs';
import '../../../hooks/useGlobalIcon.mjs';
import '../../../hooks/tnode.mjs';
import '../../../_chunks/dep-0a6fd248.mjs';
import '../../../_chunks/dep-7ad89920.mjs';
import '../../../_chunks/dep-b1013215.mjs';
import '../../../_chunks/dep-91fc304f.mjs';
import '../../../_chunks/dep-17446155.mjs';
import '../../../_chunks/dep-8747fcf0.mjs';
import '../../../utils/render-tnode.mjs';
import '../../../_chunks/dep-ec227f3f.mjs';
import '../../../input/useInput.mjs';
import '../../../form/const.mjs';
import '../../../hooks/index.mjs';
import '../../../hooks/icon.mjs';
import '../../../hooks/slot.mjs';
import '../../../hooks/useCommonClassName.mjs';
import '../../../hooks/useDefaultValue.mjs';
import '../../../hooks/useDestroyOnClose.mjs';
import '../../../hooks/useKeepAnimation.mjs';
import '../../../hooks/useRipple.mjs';
import '../../../utils/set-style.mjs';
import '../../../hooks/useVirtualScroll.mjs';
import '../../../hooks/useVModel.mjs';
import '../../../hooks/useImagePreviewUrl.mjs';
import '../../../_common/js/upload/utils.mjs';
import '../../../_common/js/log/log.mjs';
import '../../../input/useLengthLimit.mjs';
import '../../../_common/js/log/index.mjs';
import '../../../_common/js/utils/helper.mjs';
import '../../../_chunks/dep-ce88e3c0.mjs';
import '../../../_chunks/dep-a432d90f.mjs';
import '../../../input/useInputEventHandler.mjs';
import '../../../input/useInputWidth.mjs';
import '../../../hooks/useResizeObserver.mjs';
import '../../../input/input-group.mjs';
import '../../../input/input-group-props.mjs';
import '../../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../../input/type.mjs';
import '../../../input-number/input-number.mjs';
import '../../../button/index.mjs';
import '../../../button/button.mjs';
import '../../../loading/index.mjs';
import '../../../loading/directive.mjs';
import '../../../loading/plugin.mjs';
import '../../../loading/loading.mjs';
import '../../../loading/icon/gradient.mjs';
import '../../../_common/js/loading/circle-adapter.mjs';
import '../../../_common/js/utils/set-style.mjs';
import '../../../utils/dom.mjs';
import '../../../utils/easing.mjs';
import '../../../loading/props.mjs';
import '../../../hooks/useTeleport.mjs';
import '../../../loading/type.mjs';
import '../../../button/props.mjs';
import '../../../hooks/useDisabled.mjs';
import '../../../_chunks/dep-11ebe61f.mjs';
import '../../../button/type.mjs';
import '../../../input-number/props.mjs';
import '../../../input-number/useInputNumber.mjs';
import '../../../_common/js/input-number/number.mjs';
import '../../../_common/js/input-number/large-number.mjs';
import '../../../input-number/type.mjs';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FormatInputs = defineComponent({
  name: "FormatInputs",
  inheritAttrs: false,
  props: _objectSpread(_objectSpread({}, props), {}, {
    color: {
      type: Object
    },
    onInputChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  }),
  setup: function setup(props2) {
    var inputConfigs = computed(function () {
      var configs = _toConsumableArray(FORMAT_INPUT_CONFIG[props2.format]);
      if (props2.enableAlpha) {
        configs.push({
          type: "inputNumber",
          key: "a",
          min: 0,
          max: 100,
          format: function format(value) {
            return "".concat(value, "%");
          },
          flex: 1.15
        });
      }
      return configs;
    });
    var modelValue = reactive({});
    var lastModelValue = reactive({});
    var getFormatColorMap = function getFormatColorMap(type) {
      var color = props2.color;
      if (type === "encode") {
        return {
          HSV: color.getHsva(),
          HSL: color.getHsla(),
          RGB: color.getRgba(),
          CMYK: color.getCmyk(),
          CSS: {
            css: color.css
          },
          HEX: {
            hex: color.hex
          }
        };
      }
      return {
        HSV: Color.object2color(modelValue, "HSV"),
        HSL: Color.object2color(modelValue, "HSL"),
        RGB: Color.object2color(modelValue, "RGB"),
        CMYK: Color.object2color(modelValue, "CMYK"),
        CSS: modelValue.css,
        HEX: modelValue.hex
      };
    };
    var updateModelValue = function updateModelValue() {
      var format = props2.format,
        color = props2.color;
      var values = getFormatColorMap("encode")[format];
      values.a = Math.round(color.alpha * 100);
      Object.keys(values).forEach(function (key) {
        modelValue[key] = values[key];
        lastModelValue[key] = values[key];
      });
    };
    updateModelValue();
    var throttleUpdate = throttle_1(updateModelValue, 100);
    watch(function () {
      var _props2$color = props2.color,
        saturation = _props2$color.saturation,
        hue = _props2$color.hue,
        value = _props2$color.value,
        alpha = _props2$color.alpha;
      return [saturation, hue, value, alpha, props2.format];
    }, throttleUpdate);
    var handleChange = function handleChange(key, v) {
      if (v === lastModelValue[key]) {
        return;
      }
      var value = getFormatColorMap("decode")[props2.format];
      props2.onInputChange(value, modelValue.a / 100, key, v);
    };
    return {
      modelValue: modelValue,
      inputConfigs: inputConfigs,
      handleChange: handleChange
    };
  },
  render: function render() {
    var _this = this;
    var inputProps = _objectSpread({}, this.inputProps || {});
    return createVNode("div", {
      "class": "input-group"
    }, [this.inputConfigs.map(function (config) {
      return createVNode("div", {
        "class": "input-group__item",
        "key": config.key,
        "style": {
          flex: config.flex || 1
        }
      }, [config.type === "input" ? createVNode(Input, mergeProps(inputProps, {
        "align": "center",
        "size": "small",
        "disabled": _this.disabled,
        "modelValue": _this.modelValue[config.key],
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return _this.modelValue[config.key] = $event;
        },
        "maxlength": _this.format === "HEX" ? 9 : void 0,
        "title": _this.modelValue[config.key],
        "onBlur": function onBlur(v) {
          return _this.handleChange(config.key, v);
        },
        "onEnter": function onEnter(v) {
          return _this.handleChange(config.key, v);
        }
      }), null) : createVNode(InputNumber, mergeProps(inputProps, {
        "align": "center",
        "size": "small",
        "disabled": _this.disabled,
        "modelValue": _this.modelValue[config.key],
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return _this.modelValue[config.key] = $event;
        },
        "title": _this.modelValue[config.key],
        "min": config.min,
        "max": config.max,
        "step": 1,
        "format": config.format,
        "theme": "normal",
        "onBlur": function onBlur(v) {
          return _this.handleChange(config.key, v);
        },
        "onEnter": function onEnter(v) {
          return _this.handleChange(config.key, v);
        }
      }), null)]);
    })]);
  }
});

export { FormatInputs as default };
//# sourceMappingURL=inputs.mjs.map
